import Model from '@/store/model';
import CouponCodeCoupon from './coupon_code_coupon';
import User from './user';

class CouponCode extends Model {
  map(json) {
    super.map(json);

    if (json && json.coupon != undefined) {
      this.coupon = new CouponCodeCoupon();
      this.coupon.map(json.coupon);
    }
    if (json && json.user != undefined) {
      this.user = new User();
      this.user.map(json.user);
    }
  }
}
export default CouponCode;
